import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import arrowRight from "../logos/Arrow.png";
import arrowLeft from "../logos/Arrow1.png";

// ✅ Thumbnails
import thumb1 from "../thumbnails/1 טיפים פנסיה שי.jpg";
import thumb2 from "../thumbnails/2 פנסיה בר.jpg";
import thumb3 from "../thumbnails/3 דמי ניהול שי_1.jpg";
import thumb4 from "../thumbnails/4 פנסיה ביטוחים שי.jpg";
import thumb5 from "../thumbnails/5 ביטוחי בריאות שי.jpg";
import thumb6 from "../thumbnails/6 לדאוג לפנסיה בר.jpg";
import thumb7 from "../thumbnails/7 סוגי רשיונות בר.jpg";
import thumb8 from "../thumbnails/8 כפל ביטוחי שי.jpg";
import thumb9 from "../thumbnails/9 מסלולי השקעות בר.jpg";
import thumb10 from "../thumbnails/10 הצגת אובייקטיבי שי ובר.jpg";
import thumb11 from "../thumbnails/11 מערכת אובייקטיבי בר.jpg";
import thumb12 from "../thumbnails/12 ריבית דה ריבית בר.jpg";
import thumb13 from "../thumbnails/13 מכשירי השקעה בר.jpg";

// ✅ Videos
import vid1 from "../videos/1 טיפים פנסיה שי.mp4";
import vid2 from "../videos/2 פנסיה בר.mp4";
import vid3 from "../videos/3 דמי ניהול שי_1.mp4";
import vid4 from "../videos/4 פנסיה ביטוחים שי.mp4";
import vid5 from "../videos/5 ביטוחי בריאות שי.mp4";
import vid6 from "../videos/6 לדאוג לפנסיה בר.mp4";
import vid7 from "../videos/7 סוגי רשיונות בר.mp4";
import vid8 from "../videos/8 כפל ביטוחי שי.mp4";
import vid9 from "../videos/9 מסלולי השקעות בר.mp4";
import vid10 from "../videos/10 הצגת אובייקטיבי שי ובר.mp4";
import vid11 from "../videos/11 מערכת אובייקטיבי בר.mp4";
import vid12 from "../videos/12 ריבית דה ריבית בר.mp4";
import vid13 from "../videos/13 מכשירי השקעה בר.mp4";

const videoData = [
  { id: 1, duration: "0:54", title: "טיפים להגדלת הפנסיה", bgColor: thumb1, video: vid1 },
  { id: 2, duration: "0:32", title: "זה הזמן לבדוק את קרן הפנסיה", bgColor: thumb2, video: vid2 },
  { id: 3, duration: "0:38", title: "דמי ניהול בקרן פנסיה", bgColor: thumb3, video: vid3 },
  { id: 4, duration: "0:25", title: "כיסויים ביטוחיים בקרן פנסיה", bgColor: thumb4, video: vid4 },
  { id: 5, duration: "0:44", title: "ביטוחי בריאות", bgColor: thumb5, video: vid5 },
  { id: 6, duration: "0:45", title: "תתמקדו בכסף הגדול", bgColor: thumb6, video: vid6 },
  { id: 7, duration: "1:04", title: "סוגי רישיונות פנסיוניים", bgColor: thumb7, video: vid7 },
  { id: 8, duration: "0:28", title: "כפל ביטוחי", bgColor: thumb8, video: vid8 },
  { id: 9, duration: "0:51", title: "מסלולי השקעה", bgColor: thumb9, video: vid9 },
  { id: 10, duration: "0:32", title: "אובייקטיבי", bgColor: thumb10, video: vid10 },
  { id: 11, duration: "0:41", title: "המערכת שלנו", bgColor: thumb11, video: vid11 },
  { id: 12, duration: "0:41", title: "ריבית דריבית", bgColor: thumb12, video: vid12 },
  { id: 13, duration: "0:50", title: "השקעות", bgColor: thumb13, video: vid13 },
];

const VideoSlider = () => {
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleSwiper = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <div className="video-slider-wrapper" dir="rtl">
      <div className="slider-header">
        <h2 className="slider-title">
          וידאו-טיפ: מה חשוב לדעת על מה שאתם רואים כאן?
        </h2>
        <div className="slider-buttons">
          <div className="swiper-button-prev-custom">
            <img src={arrowRight} alt="הקודם" />
          </div>
          <div className="swiper-button-next-custom">
            <img src={arrowLeft} alt="הבא" />
          </div>
        </div>
      </div>

      <div className="swiper-container-fade">
        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          }}
          spaceBetween={20}
          slidesPerView="auto"
          centeredSlides={false}
          grabCursor={true}
          dir="rtl"
          onSwiper={handleSwiper}
          onSlideChange={handleSlideChange}
        >
          {videoData.map((video) => {
            console.log(video.bgColor);
            
            return (
            <SwiperSlide key={video.id} className="video-slide">
              <div
                className="video-card"
                onClick={() => {
                  setSelectedVideo(video.video);
                  setPopupOpen(true);
                }}
                style={{ cursor: "pointer" }}
              >
                 <img src={`${video.bgColor}`} alt="" className="bg_img" />
                
                <span className="duration">{video.duration}</span>
                
              </div>
              <div className="video-footer">{video.title}</div>
            </SwiperSlide>
            )
})}
        </Swiper>

        {!isBeginning && isEnd && <div className="fade-overlay fade-left"></div>}
        {!isEnd && <div className="fade-overlay fade-right"></div>}
      </div>

      {/* Video Popup */}
      {popupOpen && selectedVideo && (
        <div className="video-popup-overlay" onClick={() => setPopupOpen(false)}>
          <div className="video-popup" onClick={(e) => e.stopPropagation()}>
            <video
              width="100%"
              height="100%"
              controls
              autoPlay
              src={selectedVideo}
              style={{ borderRadius: "8px" }}
            />
            <button className="close-btn" onClick={() => setPopupOpen(false)}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoSlider;
